// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/query-new-patient.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New($appointment_booking_id: uuid!) {
  vaxiom_appointment_bookings(
    where: { _id: { _eq: $appointment_booking_id } }
  ) {
    id
    appointment {
      id
      patient {
        id
        _id
        person {
          id
          first_name
          last_name
        }
      }
    }
  }
}

`